












import { Component, Prop, Vue } from 'vue-property-decorator';
import Card from './Card.vue';

@Component({
    components: {
        Card
    }
})
export default class AdminCard extends Vue {
    @Prop({type: Number}) height: number;
    @Prop({type: Number}) width: number;
    @Prop({default: 'My recent Bookings', type: String}) headerContent: string;
    @Prop({default: 'More', type: String}) action: string;
}
